import { formatDateLong } from "../../helperfunctions/helperfunctions";
import AdminTaak from "./AdminTaak";
import AdminNewOrEditActiviteit from "./AdminNewOrEditActiviteit";
import AdminNewOrEditTaak from "./AdminNewOrEditTaak";
import { useState } from "react";

const AdminActiviteitFull = (props) => {

    const { activiteit, deleteActiviteit, closeActiviteitForm, setSelectedActiviteit } = props;
    const { _id, taken, naam, omschrijving } = activiteit;
    const [editStatus, setEditStatus] = useState({
        editMode: false,
        editID: "",
        showConfirm: false,
        addTaak: false,
        editTaak: false
    });
    const datum = formatDateLong(activiteit.datum);


    //show addTaak form
    const handleClickAddTaak = () => {
        setEditStatus({
            ...editStatus,
            addTaak: true,
            editID: _id
        });
    }

    //show and do initial fill for edit Activiteit form
    const handleClickEditAct = () => {
        setEditStatus({
            ...editStatus,
            editMode: true,
            editID: _id
        });
    }

    const handleClickDeleteAct = () => {
        deleteActiviteit(_id);
    }

    const closeEditActiviteit = () => {
        setEditStatus({
            ...editStatus,
            editMode: false,
            editID: ""
        })
    }

    const handleClose = () => {
        setSelectedActiviteit('');
    }




    return (
        <>
            <h3>Volledige info geselecteerde activiteit</h3>
            <div>
                <button onClick={handleClickAddTaak}>Taken toevoegen</button>
                <button onClick={handleClickEditAct}>Activiteit wijzigen</button>
                <button onClick={handleClickDeleteAct}>Activiteit verwijderen</button>

            </div>
            <div>
                {/* <p>{editStatus.showConfirm && "Activiteit is gewijzigd"}</p> */}
            </div>
            <div className='activiteitContainer'>
                <div>
                    <button onClick={handleClose}>Close</button>
                </div>
                <div className="adminActiviteitTop">
                    <h3>{naam}</h3>
                    <p>{datum}</p>
                </div>
                <div className='adminActiviteitOmschrijving'>
                    <p>{omschrijving}</p>
                </div>

                {(editStatus.editMode && editStatus.editID === _id) &&
                    <div>
                        <AdminNewOrEditActiviteit 
                        id={_id} 
                        mode="edit"
                        activiteit = {activiteit}
                        closeEditActiviteit = {closeEditActiviteit}
                        closeActiviteitForm = {closeActiviteitForm}
                        />
                    </div>
                }

                {(editStatus.addTaak && editStatus.editID === _id ) &&
                    <div>
                        <p>Nieuwe taak:</p>
                        <AdminNewOrEditTaak 
                            activiteitID={_id}
                            editStatus = {editStatus}
                            setEditStatus = {setEditStatus}
                            mode = "new"
                            closeActiviteitForm = {closeActiviteitForm}
                        />
                    </div>
                }


                {taken && taken.map(item => <AdminTaak 
                    taak={item} 
                    activiteitID={_id}
                    closeActiviteitForm={closeActiviteitForm} 
                    key={item._id}/>)}

            </div>
        </>
    );
}

export default AdminActiviteitFull;